/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_AwardDetailsByTransaction_AwardDetailsByTransactionIdDto } from '../models/Wealthlane_AwardService_Dtos_AwardDetailsByTransaction_AwardDetailsByTransactionIdDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class GetAwardDetailByTransactionService {

    /**
     * @param transactionId 
     * @returns Wealthlane_AwardService_Dtos_AwardDetailsByTransaction_AwardDetailsByTransactionIdDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppGetAwardDetailByTransactionRsuAwardDetailsByTransactionId(
transactionId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_AwardDetailsByTransaction_AwardDetailsByTransactionIdDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/get-award-detail-by-transaction/rsu-award-details-by-transaction-id/{transactionId}',
            path: {
                'transactionId': transactionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transactionId 
     * @returns Wealthlane_AwardService_Dtos_AwardDetailsByTransaction_AwardDetailsByTransactionIdDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppGetAwardDetailByTransactionPsuAwardDetailsByTransactionId(
transactionId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_AwardDetailsByTransaction_AwardDetailsByTransactionIdDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/get-award-detail-by-transaction/psu-award-details-by-transaction-id/{transactionId}',
            path: {
                'transactionId': transactionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transactionId 
     * @returns Wealthlane_AwardService_Dtos_AwardDetailsByTransaction_AwardDetailsByTransactionIdDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppGetAwardDetailByTransactionOptionAwardDetailsByTransactionId(
transactionId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_AwardDetailsByTransaction_AwardDetailsByTransactionIdDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/get-award-detail-by-transaction/option-award-details-by-transaction-id/{transactionId}',
            path: {
                'transactionId': transactionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
